<template>
  <div class="relative inline-block group">
    
    <div 
      v-if="tooltip"
      class="absolute bottom-full mb-2 hidden center group-hover:flex flex-col items-center"
      style="bottom: 2rem;"
    >
      <span class="relative z-10 p-2 text-xs leading-none text-white whitespace-no-wrap bg-gray-800 shadow-lg rounded">
        {{ tooltip }}
      </span>
      <div class="w-3 h-3 -mt-2 rotate-45 bg-gray-800" style="transform: rotate(45deg);"></div>
    </div>

    <button
      :class="computedClasses"
      @click="$emit('click')"
    >
      <span v-if="icon" class="mr-2">
        <font-awesome-icon :icon="icon" />
      </span>
      <slot />
    </button>
  </div>
</template>

<script>
export default {
  name: "BaseButton",
  props: {
    tooltip: {
      type: String,
      default: null,
    },
    icon: {
      type: [String, Array],
      default: null,
    },
    variant: {
      type: String,
      default: "primary",
    },
    size: {
      type: String,
      default: "md",
      validator: (v) => ["sm", "md", "lg"].includes(v),
    },
    outline: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedClasses() {
      const base = `
        inline-flex items-center justify-center font-semibold 
        transition-all duration-200 focus:outline-none rounded w-full
      `;

      const variants = {
        primary: "bg-ppd-green-light text-white hover:bg-ppd-green-dark",
        secondary: "bg-gray-200 text-gray-700 hover:bg-gray-300",
        success: "bg-green-600 text-white hover:bg-green-700",
        danger: "bg-red-600 text-white hover:bg-red-700",
        info: "bg-blue-600 text-white hover:bg-blue-700",
        warning: "bg-yellow-400 text-gray-900 hover:bg-yellow-500",
      };

      const outlines = {
        primary: "bg-transparent text-ppd-green-light border border-ppd-green-light hover:bg-ppd-green-light hover:text-white hover:border-transparent",
        secondary: "bg-transparent text-gray-700 border border-gray-400 hover:bg-gray-400 hover:text-white",
        success: "bg-transparent text-green-600 border border-green-600 hover:bg-green-600 hover:text-white",
        danger: "bg-transparent text-red-600 border border-red-600 hover:bg-red-600 hover:text-white",
        info: "bg-transparent text-blue-600 border border-blue-600 hover:bg-blue-600 hover:text-white",
        warning: "bg-transparent text-yellow-500 border border-yellow-500 hover:bg-yellow-500 hover:text-white",
      };

      const sizes = {
        sm: "text-sm px-3 py-1.5",
        md: "text-base px-4 py-2",
        lg: "text-lg px-6 py-3",
      };

      const selectedVariant = this.outline
        ? outlines[this.variant] || outlines.primary
        : variants[this.variant] || variants.primary;

      return `${base} ${selectedVariant} ${sizes[this.size]}`;
    },
  },
};
</script>

<style scoped>
  .bg-ppd-green-light { background-color: #16663e; }
  .bg-ppd-green-dark { background-color: #0f4f2f; }
  .text-ppd-green-light { color: #16663e; }
  .border-ppd-green-light { border-color: #16663e; }
</style>